import React, { useMemo } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTheme, ThemeProvider } from '@react-navigation/native';
import { ConversationListScreen } from '../../../screens/residents/messages/ConversationListScreen';

export type MessagesStackParamList = {
  ConversationList: undefined;
};

const Stack = createStackNavigator<MessagesStackParamList>();

export const MessagesStackNavigator: React.FC = () => {
  const parentTheme = useTheme();

  const transparentTheme = useMemo(() => ({
    ...parentTheme,
    colors: {
      ...parentTheme.colors,
      background: 'transparent',
    },
  }), [parentTheme]);

  return (
    <ThemeProvider value={transparentTheme}>
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen
        name="ConversationList"
        component={ConversationListScreen}
        options={{
          cardStyle: { backgroundColor: 'transparent' },
        }}
      />
    </Stack.Navigator>
    </ThemeProvider>
  );
};
